import { formsInit } from "./modules/kw-forms";

(() => {
  function formatDate(date) {
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }
  const animationIn = "fadeIn";
  const animationOut = "fadeOutUp";

  const screenBp = 990;
  const showEffect = "fadeInDown";
  const hideEffect = "fadeOutUp";
  const activeClass = "active";
  const notActiveClass = "not-active";
  const hoverClass = "hover";
  const currentUrl = window.location.href.replace(
    /([^A-za-z0-9]|\/[^A-za-z0-9])$/,
    "",
  );

  const footerCompare = document.querySelector(
    "footer.kw-footer .kw-footer--compare",
  );
  const footerCompareShowMore = footerCompare?.querySelector(
    ".kw-footer--show-more button",
  );
  if (footerCompare && footerCompareShowMore) {
    footerCompareShowMore.onclick = () => {
      footerCompare.classList.add("show-more-open");
    };
  }

  function setActiveClass() {
    const navLinks = document.querySelectorAll(
      "header .header .kw-menu--item a",
    );
    navLinks.forEach((item) => {
      if (
        item.href &&
        !item.classList.contains(notActiveClass) &&
        currentUrl === item.href.replace(/\/$/, "")
      ) {
        item.classList.add(activeClass);
      } else {
        item.classList.remove(activeClass);
      }
    });
  }

  function toggleSubMenu(submenu, action = "hide") {
    if (!submenu) return;
    if ("hide" == action) {
      submenu.onmouseleave = () => {};
    }
    if (window.innerWidth < screenBp) {
      submenu.classList.remove(hideEffect);
      submenu.classList.remove(showEffect);
      return;
    }

    window.requestAnimationFrame(() => {
      if ("show" == action) {
        submenu.classList.remove(hideEffect);
        submenu.classList.add(showEffect);
      } else {
        submenu.classList.remove(showEffect);
        submenu.classList.add(hideEffect);
      }
    });
  }

  function kwMenuOnClick(e, cb) {
    const arrow = e.target.closest(".kw-menu--arrow");
    if (arrow) {
      e.preventDefault();
    }
    if (typeof cb === "function") {
      cb(e);
    }
  }
  function kwMenuOnMouse(e, cb) {
    if (e.pointerType != "mouse") {
      return;
    }
    const arrow = e.target.closest(".kw-menu--arrow");
    if (arrow) {
      e.preventDefault();
    } else if (window.innerWidth < screenBp) {
      return;
    }
    if (typeof cb === "function") {
      cb(e);
    }
  }
  function kwMenuScrollToTop(itemSub) {
    if (!itemSub) return;
    window.requestAnimationFrame(() => {
      //scroll to top
      const elementPosition = itemSub.getBoundingClientRect().top;
      if (elementPosition < itemSub.offsetTop) {
        const hwbody = itemSub.closest(".kw-header--body-wrapper");
        hwbody.scrollTo({
          top: elementPosition - itemSub.offsetTop,
          behavior: "smooth",
        });
      }
    });
  }
  function kwMenuOnHoverInit() {
    let lastSub = null;
    let timeoutId = null;
    let mouseleavTimeoutId = null;

    return (e) => {
      if (!e.target) return;

      clearTimeout(mouseleavTimeoutId);
      const itemSub = e.target.closest(".kw-menu--item");
      const isMobile = window.innerWidth < screenBp;

      // conflict resolution: mouseover and click events on desktop
      if (!itemSub || (lastSub == itemSub && e.type == "pointerover")) {
        return;
      }
      lastSub = itemSub;

      const menuSub = itemSub.querySelector(".kw-menu-sub");
      const menuWrapper = e.target.closest(".kw-menu--wrapper");
      const hoverYet = menuWrapper.querySelector(
        `.kw-menu--item_sub.${hoverClass}`,
      );
      const itemSubHover = e.target.closest(".kw-menu--item");
      if (hoverYet && hoverYet != itemSubHover) {
        const menuSubYet = hoverYet.querySelector(".kw-menu-sub");
        toggleSubMenu(menuSubYet, "hide");
        hoverYet.classList.remove(hoverClass);
      }

      if (e.type == "click") {
        itemSub.classList.toggle(hoverClass);

        if (!itemSub.classList.contains(hoverClass)) {
          clearTimeout(timeoutId);
          toggleSubMenu(menuSub, "hide");
          const hbody = itemSub.closest(".kw-header--body");
          if (hbody) {
            hbody.onmouseleave = (e) => {
              lastSub = null;
            };
          }
        } else {
          toggleSubMenu(menuSub, "show");
        }
      } else {
        //hover
        toggleSubMenu(menuSub, "show");
        itemSub.classList.add(hoverClass);
      }

      if (isMobile && itemSub.classList.contains(hoverClass)) {
        kwMenuScrollToTop(itemSub);
      }
      //hide sub menu on mouse leave
      // wait end of animation
      timeoutId = setTimeout(() => {
        if (!isMobile && menuSub && itemSub.classList.contains(hoverClass)) {
          menuSub.onmouseleave = (e) => {
            if (itemSub.classList.contains(hoverClass)) {
              mouseleavTimeoutId = setTimeout(() => {
                lastSub = null;
                toggleSubMenu(menuSub, "hide");
                itemSub.classList.remove(hoverClass);
              }, 200);
            }
          };
        }
      }, 200);
    };
  }

  const hamburger = document.querySelector("header .header div.kw-hamburger");
  if (hamburger) {
    hamburger.onclick = () => {
      document.querySelector("body").classList.add("open");
    };
  }
  const closeBtn = document.querySelector("header .header .kw-menu--close");
  if (closeBtn) {
    closeBtn.onclick = () => {
      document.querySelector("body").classList.remove("open");
    };
  }

  setActiveClass();
  const kwMenu = document.querySelector(".kw-menu");
  if (kwMenu) {
    const kwMenuOnHover = kwMenuOnHoverInit();
    kwMenu.addEventListener("click", (e) => kwMenuOnClick(e, kwMenuOnHover));
    kwMenu.addEventListener("pointerover", (e) =>
      kwMenuOnMouse(e, kwMenuOnHover),
    );
  }

  const body = document.querySelector("body");
  function openDialog(dialog, dialogClass, cb = () => {}) {
    dialog.showModal();
    body.classList.add(`${dialogClass}-open`);
    const main = dialog.querySelector(`div[data-name="${dialogClass}"]`);
    const kwForm = main?.querySelector("div.kw-form:not(.hidden)");

    if (kwForm) {
      // kwForm.addEventListener("submit", roistatEventSend);
      main.style.setProperty("max-height", "calc(100vh - 90px)");
      // main.style.setProperty("height", `${kwForm.offsetHeight}px`);
      cb(dialog, dialogClass);
    }
  }
  function dialogClickInit(dialog, dialogClass) {
    const btnOk = dialog.querySelector("button[data-name=kw-form-ok]");
    const closeDialog = () => {
      btnOk?.click();
      body.classList.remove(`${dialogClass}-open`);
      dialog.close();

      const main = dialog.querySelector(`div[data-name="${dialogClass}"]`);
      main.style.setProperty("height", "auto");

      const kwForm = main?.querySelector("div.kw-form:not(.hidden)");
      if (kwForm) {
        // kwForm.removeEventListener("submit", roistatEventSend);
      }
    };
    dialog.onclose = (e) => {
      e.preventDefault();
      closeDialog();
    };
    dialog.onclick = (e) => {
      if (
        e.target.dataset?.action === "close" ||
        !e.target.closest(`.${dialogClass}--body`)
      ) {
        closeDialog();
      }
    };
  }
  function dialogInit(dialogClass, cb = () => {}) {
    const dialog = document.getElementById(dialogClass);
    if (dialog) {
      dialogClickInit(dialog, dialogClass);
      formsInit(`div[data-name="${dialogClass}"]`);
      const callDialogBtns = document.querySelectorAll(
        `button[data-action="${dialogClass}"]`,
      );

      const dateInputs = dialog.querySelectorAll('input[type="date"]');
      const currentDate = new Date().toISOString().split("T")[0];
      dateInputs.forEach((inputItem) => {
        inputItem.min = currentDate;
      });

      callDialogBtns.forEach((btn) => {
        btn.onclick = () => {
          const inputName = dialog.querySelector('input[name="form_name"]');
          const formName = btn.dataset.formName;
          if (inputName && formName) {
            inputName.value = formName;
          }
          openDialog(dialog, dialogClass, cb);
        };
      });
    } else {
      console.log("dialog is null");
    }
  }

  const dateTimeRadioCb = (dialog, dialogClass) => {
    const dateInputWrapAll = dialog.querySelectorAll(
      `.${dialogClass}--date-wrap.hide`,
    );

    const radioButtons = dialog.querySelectorAll(
      `.${dialogClass}--radio input[type="radio"][name="time_reply"]`,
    );

    const showOrHideDateInput = (radio) => {
      if (!radio.checked) {
        return;
      }
      if (radio.dataset.key === "slot") {
        dateInputWrapAll?.forEach((wrap) => {
          wrap.classList.remove("hide");
          const container = wrap.querySelector(".date-container");
          wrap.style.setProperty("max-height", `${container.offsetHeight}px`);
          wrap.style.setProperty("height", `${container.offsetHeight}px`);
          wrap.classList.add("animated", animationIn);
        });
      } else {
        dateInputWrapAll?.forEach((wrap) => {
          wrap.style.setProperty("max-height", `0px`);
          wrap.style.setProperty("height", `0px`);
          wrap.classList.remove("animated", animationIn);
          wrap.classList.add("hide");
        });
      }
    };

    radioButtons?.forEach((radio) => {
      radio.onchange = () => showOrHideDateInput(radio);
      setTimeout(() => showOrHideDateInput(radio), 0);
    });
    dateInputWrapAll?.forEach((wrap) => {
      const uiInput = wrap.querySelector(".date-wrapper");
      const real =
        wrap.querySelector('input[type="date"]') ||
        wrap.querySelector('input[type="time"]');
      const fake = wrap.querySelector('input[type="text"]');
      if (fake) {
        real.onchange = () => {
          const date = new Date(real.value);
          if (!isNaN(date)) {
            fake.value = formatDate(date);
          }
        };
      }
      uiInput.onclick = () => {
        try {
          real.showPicker();
        } catch {
          real.click();
        }
      };
    });
  };

  dialogInit("kw-dialog-call", dateTimeRadioCb);
  dialogInit("kw-dialog-demo", dateTimeRadioCb);
  dialogInit("kw-dialog-download");
})();
